<template>
  <div class="d-flex flex-column align-self-start div-100">
    <v-card flat class="my-1">
      <v-textarea
        ref="textarea"
        :placeholder="$t('qna.textarea.placeholder')"
        class="py-4"
        rows="2"
        row-height="30"
        auto-grow
        v-model="question"
        append-outer-icon="mdi-send"
        @click:append-outer="postNewQuestion"
        v-on:blur="postNewQuestion"
        v-on:keydown.enter.exact="$event.target.blur()"
        v-on:keyup.enter.alt.exact="addLineBreak()"
      ></v-textarea>
      <!-- <v-divider /> -->
    </v-card>
    <v-card flat min-height="256" :max-height="$vuetify.breakpoint.mobile?'calc(100vh - 124px - 96px)': 'calc(100vh - 124px - 96px - 36px - 92px)'">
      <v-tabs
        class="scroller"
        grow
        active-class="activeTab"
        style="height:100%"
      >
      <!-- style="height: calc(100vh - 48px)" -->
        <v-tab href="#unanswered">{{ $t("qna.tabs.open") }}</v-tab>
        <v-tab href="#answered">{{ $t("qna.tabs.answered") }}</v-tab>

        <v-tab-item
          class="mt-1"
          id="unanswered"
          style="max-heigth: 100%; overflow-y: auto"
        >
          <QnAListWrapper
            :list="AnsweredUnQuestions"
            :canVote="canVote"
          ></QnAListWrapper>
        </v-tab-item>

        <v-tab-item
          class="mt-1"
          id="answered"
          style="max-heigth: 100%; overflow-y: auto"
        >
          <QnAListWrapper
            :list="AnsweredQuestions"
            :canVote="canVote"
          ></QnAListWrapper>
        </v-tab-item>
      </v-tabs>
    </v-card>
    <!-- <v-btn fab icon class="v-btn--example mr-6 mb-6" color="primary"><v-icon>mdi-plus</v-icon></v-btn> -->
  </div>
</template>

<script>
// import QnAItem from "./QnAItem";
import { mapState, mapGetters } from "vuex";
import { storeQnA } from "./store";
import EventBus from "_shared/EventBus";
import "_shared/styles/scroller.scss";
import QnAListWrapper from "./QnAListWrapper.vue";


export default {
  components: {
    // QnAItem,
    QnAListWrapper,    
  },
  props: {
    roomName: { type: String, required: true },
    canVote: { type: Boolean, default: true },
  },
  data: () => ({
    question: "",
    items: [{ _id: { id: 1 }, question: "Hello" }],
  }),
  computed: {
    ...mapGetters(["EventId"]),
    ...mapState({
      loading(state, getters) {
        return getters[`qna-${this.EventId}-${this.roomName}/GET_loading`];
      },
      AnsweredQuestions(state, getters) {
        return getters[
          `qna-${this.EventId}-${this.roomName}/GET_AnsweredQuestions`
        ];
      },
      AnsweredUnQuestions(state, getters) {
        return getters[
          `qna-${this.EventId}-${this.roomName}/GET_AnsweredUnQuestions`
        ];
      },
    }),
  },
  async mounted() {
    await window.qnahub.start();
    this.registerStore();
  },
  created() {
    EventBus.$on("qnaroom_init", async () => {
      this.registerStore();
    });
  },
  async beforeDestroy() {
    await window.qnahub.stop();
    EventBus.$off("qnaroom_init");
  },
  methods: {
    addLineBreak() {
      this.question += "\n";
    },
    async postNewQuestion() {
      this.question = this.question.replace(/^\s+|\s+$/g, "");

      if (this.question.trim().length > 0) {
        this.$qnahub.askQuestion(this.question, this.roomName, this.EventId);

        this.question = "";
        this.$refs.textarea.blur();
      }
    },
    registerStore() {
      if (this.EventId != null) {
        if (!this.$store.hasModule(`qna-${this.EventId}-${this.roomName}`)) {
          this.$store.registerModule(
            `qna-${this.EventId}-${this.roomName}`,
            storeQnA
          );
        }
        this.$qnahub.JoinQnARoom(this.roomName, this.EventId);
      }
    },
  },
};
</script>

<style>
.flip-list-move {
  transition: transform 1s;
}
.v-btn--example {
  bottom: 0;
  right: 0;
  position: absolute;
}
.activeTab {
  font-family: Bold;
  font-weight: 100;
}

.virtual-scroller {
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>